/** Origin of the local Vouch backend (no path). */
export const DEFAULT_DEV_BACKEND_ORIGIN = "http://localhost:9393";

/** Default API base when {@link VouchConfig.baseUrl} is omitted (local dev only). */
export const DEFAULT_DEV_BASE_URL = `${DEFAULT_DEV_BACKEND_ORIGIN}/api/v1`;

/** Resolve API base URL: explicit config → `VOUCH_BASE_URL` (Node) → local dev default. */
export function resolveBaseUrl(explicit?: string): string {
  const fromConfig = explicit?.trim();
  if (fromConfig) return fromConfig.replace(/\/$/, "");

  if (typeof process !== "undefined" && typeof process.env?.VOUCH_BASE_URL === "string") {
    const fromEnv = process.env.VOUCH_BASE_URL.trim();
    if (fromEnv) return fromEnv.replace(/\/$/, "");
  }

  return DEFAULT_DEV_BASE_URL;
}
